// Vue
import Vue from 'vue';
import moment from 'moment-timezone';
import VueMoment from 'vue-moment';
moment.tz.setDefault('UTC');

// PWA Support
//import './registerServiceWorker';

// Vuex
import { sync } from 'vuex-router-sync';
import store from './store';

// Router
import router from './router';

// Vuex router sync
sync(store, router);

//styles
import './assets/scss/main.scss';

// Plugins

// Components
import App from './AppComponent.vue';

// Env
import { env } from './env';

// Vuetify
import vuetify from '@/plugins/vuetify';

// i18n
import i18n from '@/plugins/i18n';

//toast
import Toast from 'vue-toastification';
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css';

//Avoid duplicates notifications
const filterBeforeCreate = (toast: any, toasts: any) => {
  if (toasts.filter((t: any) => t.content === toast.content).length !== 0) {
    return false;
  }
  return toast;
};
Vue.use(Toast, { filterBeforeCreate });

// Setup
Vue.config.productionTip = false;

Vue.use(VueMoment, { moment });

// Global Functions
Vue.prototype.isOldEdge = () => {
  return /Edge/.test(navigator.userAgent);
};
Vue.prototype.isChrome = () => {
  return /Chrome/.test(navigator.userAgent);
};

Vue.prototype.selectedLanguage = (value: string) => {
  if (!value) {
    return env.i18nFallbackLocale;
  }
  return value;
};

Vue.filter('capitalize', (value: string) => {
  if (!value) {
    return '';
  }
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

export function logger(logLevel: any, message: any, piiEnabled: any) {
  console.log(`[MSAL] ${logLevel}`, message);
}

//Applications insights
import { useAppInsights } from './plugins/ApplicationInsights';
Vue.config.errorHandler = function(err) {
  console.log(err);
  useAppInsights().trackException({ exception: new Error(err.message) });
};

useAppInsights().trackEvent({ name: 'App Loaded!' });

// Vue init
const app = new Vue({
  el: 'app',
  render: (h: any) => h(App),
  router,
  store,
  vuetify,
  i18n,
  components: {
    App
  }
});
